import React, {Fragment, useContext, useRef} from 'react';
import ReactToPrint from "react-to-print";
import {
    EuiBreadcrumbs,
    EuiButton,
    EuiPageContent,
    EuiPageContentHeader,
    EuiPageContentHeaderSection,
    EuiSpacer,
    EuiTitle
} from '@elastic/eui';
import InvoicePrintContainer from "./invoice-print-container";
import {Store} from '../../../app/stores/store-root';
import {useHistory} from "react-router-dom";
import MessageModal from "../../../app/common/message-modal";

const InvoicePage = () => {
    const componentRef: any = useRef();
    const store = useContext(Store);
    const history = useHistory();
    const {openModal, closeModal} = store.Modal
    const breadcrumbs = [
        {
            text: 'Remittance App',
            href: '#',
            onClick: (e: any) => {
                e.preventDefault();
            },
            'data-test-subj': 'breadcrumbsAnimals',
        },
        {
            text: 'Print',
        },
    ];

    const onPay = async () => {

          if (store.Orders.CurrentOrder){
            try {
                await store.Orders.PayOrder(store.Orders.CurrentOrder);
                const message = `Order ${store.Orders.CurrentOrder.Reference} has been paid successfully.`
                openModal(
                    <MessageModal message={message} success={true}/>
                );
                history.push("/");
            } catch (error) {
                closeModal();
                const message = `Unable to pay order ${store.Orders.CurrentOrder.Reference}. The following error message returned from the server. ${error.response.data.error}.`
                store.Modal.openModal(
                    <MessageModal message={message} success={false}/>
                );
            }
        }

    }

    return (
        <Fragment>
            <EuiPageContent>
                <EuiBreadcrumbs
                    breadcrumbs={breadcrumbs}
                    truncate={false}
                    aria-label="An example of EuiBreadcrumbs"
                />
                <EuiSpacer/>
                <EuiPageContentHeader>
                    <EuiPageContentHeaderSection>
                        <EuiTitle size="l">
                            <h1>Print & Close</h1>
                        </EuiTitle>
                    </EuiPageContentHeaderSection>
                    <EuiPageContentHeaderSection>
                        <ReactToPrint
                            trigger={() => <EuiButton>Print & Close as paid</EuiButton>}
                            content={() => componentRef.current}
                            onAfterPrint={() => onPay()}
                        />
                    </EuiPageContentHeaderSection>
                </EuiPageContentHeader>
            </EuiPageContent>
            <EuiSpacer size="xs"/>
            <div>
                <InvoicePrintContainer ref={componentRef}/>
            </div>
        </Fragment>
    );
};

export default InvoicePage;